import { NgModule } from '@angular/core';
import { Store } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BcConfigService } from 'common/config/provider';
import { initializeModule } from './actions/desktop-notifications.actions';
import { GenesysCloudDesktopNotificationEffects } from './effects/desktop-notifications.effects';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      GenesysCloudDesktopNotificationEffects
    ])
  ]
})

export class GenesysCloudDesktopNotificationsModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    if (configService.current.features.genesysDxChat) {
      store.dispatch(initializeModule());
    }
  }
}
